export default __webpack_public_path__ + "static/media/logo.6a987910.svg";